import { ICoreContext } from '@msdyn365-commerce/core';
import { AsyncResult, Customer } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';

import { GetCookie } from '../cookie-utilities';

/** The ExtensionProperties key returned by GetOrganizationCustomer. */
export const HIDE_PRICES_EXTENSION_PROPERTY_KEY = 'DOCUMENTNOPRICE';
/** Test-only override. Set this cookie to `true` to hide prices for the current browser. */
export const HIDE_PRICES_TEST_COOKIE = 'defa-hide-prices';

export const shouldHidePrices = (organizationCustomer: Customer | undefined): boolean => {
    const property = organizationCustomer?.ExtensionProperties?.find(
        extensionProperty => extensionProperty.Key?.toUpperCase() === HIDE_PRICES_EXTENSION_PROPERTY_KEY
    );
    const value = property?.Value;

    return value?.BooleanValue === true || value?.StringValue?.toLowerCase() === 'true';
};

/**
 * Reads the server-resolved GetOrganizationCustomer action from the request cache.
 * The action must be registered as a server data action by a module on the page.
 */
export const getOrganizationHidePrices = (context: ICoreContext): boolean => {
    const isTestOverrideEnabled = GetCookie(context.request.cookies, HIDE_PRICES_TEST_COOKIE)?.toLowerCase() === 'true';
    const organizationCustomer = context.actionContext
        .getAll<AsyncResult<Customer>>('OrganizationCustomer')
        ?.map(result => result.result)
        .find(customer => customer !== undefined);

    return isTestOverrideEnabled || shouldHidePrices(organizationCustomer);
};

export const useOrganizationHidePrices = getOrganizationHidePrices;

/** Renders a monetary value only when the organization is allowed to see prices. */
export const OrganizationPrice: React.FC<{ context: ICoreContext }> = ({ context, children }) => {
    const hidePrices = useOrganizationHidePrices(context);
    return !hidePrices ? React.createElement(React.Fragment, undefined, children) : null;
};
